import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <a href="#">Privacidad y transparencia</a>
        <a href="#">Términos y condiciones</a>
        <a href="#">Tour y manual de usuario</a>
        <a href="/EduRAG-landing/equipo">Conoce el equipo de desarrollo: ESIA³</a>
      </div>
    </footer>
  );
}

export default Footer;
